module.exports = __webpack_public_path__ + "img/green_136.87133707.png";